var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow-1 equipment-props-curve d-flex flex-column"},[_c('charts',{staticClass:"flex-grow-1",attrs:{"chartId":_vm.chartId,"options":_vm.chartDatas}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }